import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { StepByStepElement } from "./components/StepByStepElement.js";
import styles from "./StepByStep.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function StepByStep({
  elements,
  className,
  initialActiveIndex,
  variant = 'WHITE'
}) {
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex);
  const handleSetActiveIndex = useCallback(index => {
    setActiveIndex(i => index === i ? undefined : index);
  }, [setActiveIndex]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.stepByStep, className, styles[`variant${variant}`]),
    style: {
      '--amount-elements': elements.length
    },
    children: elements.map((element, index) => {
      return /*#__PURE__*/_jsx(StepByStepElement, {
        active: index === activeIndex,
        setActive: handleSetActiveIndex.bind({}, index),
        ...element
      }, element.id ?? index);
    })
  });
}